import { Button } from "@/components/ui";

import { isLive, runStatusOf } from "../lib/runState";
import { useConsole } from "../store";
import type { AddedActivityRow } from "../types";

/** Start, Pause and Stop for one space. Each cascades and answers one outcome per activity. */
export function SpaceVerbs({
  spaceId,
  added,
  size,
}: {
  readonly spaceId: string;
  readonly added: readonly AddedActivityRow[];
  readonly size?: "sm" | "md";
}) {
  const runSpaceVerb = useConsole((state) => state.runSpaceVerb);
  const statuses = added.map((one) => runStatusOf(one.mount));
  const live = statuses.filter(isLive);
  const allPaused = live.length > 0 && live.every((status) => status === "paused");

  return (
    <div className="cx-verbs">
      <Button
        variant="secondary"
        size={size ?? "sm"}
        disabled={added.length === 0 || (live.length === added.length && !allPaused)}
        onClick={() => {
          runSpaceVerb(spaceId, "Start");
        }}
      >
        {allPaused ? "Resume" : "Start"}
      </Button>
      <Button
        variant="secondary"
        size={size ?? "sm"}
        disabled={live.length === 0 || allPaused}
        onClick={() => {
          runSpaceVerb(spaceId, "Pause");
        }}
      >
        Pause
      </Button>
      <Button
        variant="destructive"
        size={size ?? "sm"}
        disabled={live.length === 0}
        onClick={() => {
          runSpaceVerb(spaceId, "Stop");
        }}
      >
        Stop
      </Button>
    </div>
  );
}
